/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconInnerShadowBottomRightFilled = createReactComponent("filled", "inner-shadow-bottom-right-filled", "IconInnerShadowBottomRightFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm6 9a1 1 0 0 0 -1 1a5 5 0 0 1 -5 5a1 1 0 0 0 0 2a7 7 0 0 0 7 -7a1 1 0 0 0 -1 -1z", "key": "svg-0" }]]);

export { IconInnerShadowBottomRightFilled as default };
//# sourceMappingURL=IconInnerShadowBottomRightFilled.mjs.map
